<template>
  <div class="home-container">
    <!-- 头部欢迎区域 -->
    <div class="welcome-section">
      <div class="welcome-content">
        <h1 class="welcome-title">代码技能库</h1>
        <p class="welcome-subtitle">收集和展示各类组件的个性化用法，助力快速开发</p>
        <div class="quick-stats">
          <div class="stat-item">
            <div class="stat-number">3</div>
            <div class="stat-label">平台</div>
          </div>
          <div class="stat-item">
            <div class="stat-number">5+</div>
            <div class="stat-label">组件</div>
          </div>
          <div class="stat-item">
            <div class="stat-number">10+</div>
            <div class="stat-label">技能</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 平台入口卡片 -->
    <div class="platform-section">
      <h2 class="section-title">选择平台</h2>
      <el-row :gutter="24">
        <!-- PC端 -->
        <el-col :xs="24" :sm="8">
          <div class="platform-card pc-card" @click="navigateTo('/form/input')">
            <div class="platform-icon">
              <i class="el-icon-monitor"></i>
            </div>
            <h3 class="platform-title">PC端</h3>
            <p class="platform-desc">Element UI组件个性化用法，包括表单、日期选择器、地图等</p>
            <div class="platform-tags">
              <el-tag size="small" effect="plain" class="clickable-tag" @click.stop="navigateTo('/form/input')">输入框</el-tag>
              <el-tag size="small" effect="plain" class="clickable-tag" @click.stop="navigateTo('/form/select')">选择器</el-tag>
              <el-tag size="small" effect="plain" class="clickable-tag" @click.stop="navigateTo('/map/track')">地图</el-tag>
            </div>
            <div class="platform-arrow">
              <i class="el-icon-arrow-right"></i>
            </div>
          </div>
        </el-col>

        <!-- APP端 -->
        <el-col :xs="24" :sm="8">
          <div class="platform-card app-card" @click="navigateTo('/app')">
            <div class="platform-icon">
              <i class="el-icon-mobile-phone"></i>
            </div>
            <h3 class="platform-title">APP端</h3>
            <p class="platform-desc">移动端开发技巧，包括UI适配、手势交互等</p>
            <div class="platform-tags">
              <el-tag size="small" effect="plain">建设中</el-tag>
            </div>
            <div class="platform-arrow">
              <i class="el-icon-arrow-right"></i>
            </div>
          </div>
        </el-col>

        <!-- 小程序端 -->
        <el-col :xs="24" :sm="8">
          <div class="platform-card mini-card" @click="navigateTo('/miniprogram')">
            <div class="platform-icon">
              <i class="el-icon-chat-dot-round"></i>
            </div>
            <h3 class="platform-title">小程序端</h3>
            <p class="platform-desc">微信小程序开发技巧，组件封装与优化</p>
            <div class="platform-tags">
              <el-tag size="small" effect="plain">建设中</el-tag>
            </div>
            <div class="platform-arrow">
              <i class="el-icon-arrow-right"></i>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>

    <!-- 最新技能 -->
    <div class="skills-section">
      <h2 class="section-title">热门技能</h2>
      <el-row :gutter="20">
        <el-col :xs="24" :sm="12" :md="8" :lg="6" v-for="skill in hotSkills" :key="skill.id">
          <div class="skill-card" @click="navigateTo(skill.path)">
            <div class="skill-header">
              <i :class="skill.icon" :style="{ color: skill.color }"></i>
              <span class="skill-category">{{ skill.category }}</span>
            </div>
            <h4 class="skill-title">{{ skill.title }}</h4>
            <p class="skill-desc">{{ skill.description }}</p>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Home',
  data() {
    return {
      hotSkills: [
        {
          id: 1,
          title: '自定义样式输入框',
          description: '深色背景、自定义边框和占位符颜色',
          icon: 'el-icon-edit',
          color: '#409EFF',
          category: 'PC端',
          path: '/form/input'
        },
        {
          id: 2,
          title: '多选下拉框',
          description: '支持全选功能的多选下拉框',
          icon: 'el-icon-arrow-down',
          color: '#67C23A',
          category: 'PC端',
          path: '/form/select'
        },
        {
          id: 3,
          title: '日期时间范围',
          description: '完整的日期时间范围选择器',
          icon: 'el-icon-date',
          color: '#E6A23C',
          category: 'PC端',
          path: '/form/date'
        },
        {
          id: 4,
          title: '轨迹回放',
          description: '高德地图轨迹回放功能',
          icon: 'el-icon-map-location',
          color: '#F56C6C',
          category: 'PC端',
          path: '/map/track'
        }
      ]
    }
  },
  methods: {
    navigateTo(path) {
      this.$router.push(path);
    }
  }
}
</script>

<style scoped>
.home-container {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  /* 撑满内容区（已扣除内容区 12px 内边距），不再手算 calc(100vh - Npx) */
  height: 100%;
  box-sizing: border-box;
  overflow: auto;
  border-radius: 8px;
  padding: 32px 30px;
}

/* 欢迎区域 */
.welcome-section {
  text-align: center;
  color: #ffffff;
  margin-bottom: 50px;
}

.welcome-title {
  font-size: 42px;
  font-weight: 700;
  margin: 0 0 16px 0;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
}

.welcome-subtitle {
  font-size: 18px;
  opacity: 0.9;
  margin: 0 0 40px 0;
}

.quick-stats {
  display: flex;
  justify-content: center;
  gap: 60px;
}

.stat-item {
  text-align: center;
}

.stat-number {
  font-size: 36px;
  font-weight: 700;
  line-height: 1;
  margin-bottom: 8px;
}

.stat-label {
  font-size: 14px;
  opacity: 0.8;
}

/* 平台入口 */
.platform-section {
  margin-bottom: 50px;
}

.section-title {
  color: #ffffff;
  font-size: 24px;
  font-weight: 600;
  margin: 0 0 24px 0;
  text-align: center;
}

.platform-card {
  background: var(--surface-1);
  border-radius: 12px;
  padding: 30px 24px;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  height: 240px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

.platform-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.2);
}

.platform-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
}

.pc-card::before {
  background: linear-gradient(90deg, #409EFF, #67C23A);
}

.app-card::before {
  background: linear-gradient(90deg, #E6A23C, #F56C6C);
}

.mini-card::before {
  background: linear-gradient(90deg, #9C27B0, #673AB7);
}

.platform-icon {
  width: 60px;
  height: 60px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
}

.pc-card .platform-icon {
  background: linear-gradient(135deg, #409EFF, #66b1ff);
}

.app-card .platform-icon {
  background: linear-gradient(135deg, #E6A23C, #f0c78a);
}

.mini-card .platform-icon {
  background: linear-gradient(135deg, #9C27B0, #ba68c8);
}

.platform-icon i {
  font-size: 28px;
  color: #ffffff;
}

.platform-title {
  font-size: 20px;
  font-weight: 600;
  color: #303133;
  margin: 0 0 12px 0;
}

.platform-desc {
  font-size: 14px;
  color: #606266;
  line-height: 1.6;
  margin: 0 0 16px 0;
}

.platform-tags {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.clickable-tag {
  cursor: pointer;
  transition: all 0.3s ease;
}

.clickable-tag:hover {
  transform: translateY(-4px);
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-color: transparent;
  color: #ffffff;
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
}

.platform-arrow {
  position: absolute;
  bottom: 24px;
  right: 24px;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: var(--surface-2);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}

.platform-card:hover .platform-arrow {
  background: #409EFF;
  color: #ffffff;
}

.platform-arrow i {
  font-size: 14px;
}

/* 技能卡片 */
.skills-section {
  margin-bottom: 30px;
}

.skill-card {
  background: rgba(255, 255, 255, 0.95);
  border-radius: 8px;
  padding: 20px;
  cursor: pointer;
  transition: all 0.3s ease;
  height: 160px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

.skill-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
}

.skill-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}

.skill-header i {
  font-size: 24px;
}

.skill-category {
  font-size: 12px;
  color: #909399;
  background: var(--surface-2);
  padding: 4px 10px;
  border-radius: 12px;
}

.skill-title {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
  margin: 0 0 8px 0;
}

.skill-desc {
  font-size: 13px;
  color: #606266;
  line-height: 1.5;
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

/* 响应式 */
@media (max-width: 768px) {
  .welcome-title {
    font-size: 32px;
  }

  .welcome-subtitle {
    font-size: 16px;
  }

  .quick-stats {
    gap: 40px;
  }

  .stat-number {
    font-size: 28px;
  }

  .platform-card {
    margin-bottom: 20px;
    height: auto;
    min-height: 220px;
  }

  .skill-card {
    margin-bottom: 16px;
  }
}
</style>
